var tab1 = document.getElementById("tab1");
var tab2 = document.getElementById("tab2");
if (tab1) {
  var panelTab1 = document.getElementById("panel-tab1");
  var panelTab2 = document.getElementById("panel-tab2");

  tab1.addEventListener("click", function () {
    tab1.classList.add("active");
    panelTab1.classList.add("active");

    tab2.classList.remove("active");
    panelTab2.classList.remove("active");
  });

  tab2.addEventListener("click", function () {
    tab2.classList.add("active");
    panelTab2.classList.add("active");

    tab1.classList.remove("active");
    panelTab1.classList.remove("active");
  });
}

var links = document.querySelectorAll(".calendar td a");

links.forEach(function (link) {
  link.addEventListener("click", function (event) {
    event.preventDefault();

    var id = this.getAttribute("href").substr(1);

    if (id) {
      console.log(id);
      var scrollableDivs = document.querySelectorAll(".scrollable-div");

      scrollableDivs.forEach(function (div) {
        var targetElement = div.querySelector(`[data-id="${id}"]`);
        if (targetElement) {
          console.log(targetElement.offsetTop);
          div.scrollTop = targetElement.offsetTop - 40;
        }
      });
    }
  });
});

const links2 = document.querySelectorAll(".event__link-cal");
links2.forEach((link) => {
  link.addEventListener("click", function (event) {
    event.preventDefault();
    event.stopPropagation();

    const addToCalendar = link.parentElement.querySelector(".add-to-calendar");
    if (addToCalendar) {
      addToCalendar.classList.add("active");
    }
  });
});

document.addEventListener("click", function () {
  const activeElements = document.querySelectorAll(".add-to-calendar.active");
  activeElements.forEach((el) => {
    el.classList.remove("active");
  });
});

const buttons = document.querySelectorAll(".event__button");

buttons.forEach((button) => {
  button.addEventListener("click", function (event) {
    event.preventDefault();

    document.querySelector("#tab2").classList.add("active");
    document.querySelector("#panel-tab2").classList.add("active");
    document.querySelector("#tab1").classList.remove("active");
    document.querySelector("#panel-tab1").classList.remove("active");

    const hrefValue = button.getAttribute("href");

    if (hrefValue) {
      const scrollableDiv = document.querySelector(
        "#panel-tab2 .scrollable-div"
      );
      const targetElement = document.querySelector(hrefValue);

      if (scrollableDiv && targetElement) {
        scrollableDiv.scrollTop = targetElement.offsetTop;
      }
    }
  });
});
